import { Box, Typography } from '@mui/material'
import React from 'react'

import { HdpNavigationTab } from '@f-fertighaus/applications/Next/components/common/navigation/tabs/useActiveTabs'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'

import { EnergyStandardAndFunding } from './EnergyStandardAndFunding'
import { RoofInformation } from './RoofInformation/RoofInformation'

export const DetailSection = () => {
  const {
    state: { name }
  } = useHouseDetail()
  return (
    <Box sx={{ marginTop: 2 }}>
      <Box sx={{ marginBottom: 0, py: 2 }}>
        <Typography
          component='h2'
          id={`navigation-category-${HdpNavigationTab.details}`}>
          <Typography variant='mediumTitle' component='span' display='block'>
            {t('houseDetailPage.details')}
          </Typography>
          <Typography component='span' variant='body2' display='block'>
            {t('houseDetailPage.heading_suffix', { houseName: name })}
          </Typography>
        </Typography>
      </Box>
      <EnergyStandardAndFunding />
      <RoofInformation />
    </Box>
  )
}
